import { useFormikContext } from 'formik';
import React from 'react';
import FolioCheckbox from '@/components/FolioCheckbox';
import { Box } from '@mui/material';
import { useClientSchemaContext } from '@/context/clientSchemaContext';
import { useUpdateContactMutation } from '@/features/contacts/contactsApi';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import { useParams } from 'react-router-dom';
import { VIEW_TYPES } from '@/features/config/helper';
import { useSelector } from 'react-redux';

const IsMainContact = ({ index, disabled }) => {
	const params = useParams();
	const { values, setFieldValue } = useFormikContext();
	const { view, variant } = useClientSchemaContext();
	const dialogData = useSelector((state) => state.dialog);
	const clientId = params?.clientId ?? dialogData?.data?.clientDialog?.clientId;

	const [updateContact, contactUpdateState] = useUpdateContactMutation();

	const checked = values.contacts?.[index]?.isMainContact ?? (values.contacts ?? []).length <= 1;

	const { currentData: clientRow } = useGetClientRowQuery(clientId, {
		skip: view === VIEW_TYPES.create || !clientId,
	});

	const setMainContact = async () => {
		const newContacts = values.contacts.map((contact, i) => ({
			...contact,
			isMainContact:
				variant === 'addContact' ? i === index && !contact.isMainContact : i === index,
		}));
		setFieldValue('contacts', newContacts);

		if (values.contacts[index]?.Id && view === VIEW_TYPES.update) {
			await updateContact({
				insightId: values.contacts[index].Id,
				isMainContact: true,
				clientId: clientRow?.clientId,
			}).unwrap();
		}
	};

	return (
		<Box pt='17.25px'>
			<FolioCheckbox
				checked={checked}
				label={'Is main contact'}
				onChange={() => {
					console.log('variant', variant);
					if (checked && variant !== 'addContact') return;
					setMainContact();
				}}
				disabled={
					disabled ||
					contactUpdateState.isLoading ||
					(variant !== 'addContact' && (values.contacts ?? []).length <= 1)
				}
			/>
		</Box>
	);
};

export default IsMainContact;
